/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/barcode/BarcodeScannerConfiguration.yaml
import { PartiallyConstructible } from '../../utils/utils';
/**
Configuration of the scanning behavior.
*/
export class CommonBarcodeScannerConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CommonBarcodeScannerConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          List of document formats to be extracted.
          
          Defaults to all document formats.
          */
        this.extractedDocumentFormats = [
            'AAMVA',
            'BOARDING_PASS',
            'DE_MEDICAL_PLAN',
            'MEDICAL_CERTIFICATE',
            'ID_CARD_PDF_417',
            'SEPA',
            'SWISS_QR',
            'VCARD',
            'GS1',
            'HIBC',
        ];
        /**
          If `true` and extractedDocumentFormats is not empty, then barcodes that do not decode to one of the accepted document formats will be ignored.
          
          Default is false
          */
        this.onlyAcceptDocuments = false;
        /**
          Filter for extended EAN and UPC barcodes.
          
          Default is ALLOW_ANY
          */
        this.extensions = 'ALLOW_ANY';
        /**
          Regular expression filter for barcode text. If the barcode text does not match the regular expression, it will not be scanned. The default is an empty string (setting is turned off). This option overrides `barcodesExtensionFilter` option.
          
          Default is ""
          */
        this.barcodesRegexFilter = '';
        /**
          Minimum acceptable value of a result BarcodeItem's sizeScore (between 0 and 1). Barcodes with a sizeScore less than this value will not be scanned. When set to 0, barcodes are returned no matter what their size is.
          
          Default is 0
          */
        this.minimumSizeScore = 0.0;
        /**
          Optional minimum required text length of the detected barcode. The default is 0 (setting is turned off). NOTE - This feature works on ITF barcodes only.
          
          Default is 0
          */
        this.minimumTextLength = 0;
        /**
          Optional maximum text length of the detected barcode. The default is 0 (setting is turned off). NOTE - This feature works on ITF barcodes only.
          
          Default is 0
          */
        this.maximumTextLength = 0;
        /**
          Optional minimum required quiet zone on the barcode. Measured in modules (the smallest bar size on a barcode). The default is 10. NOTE - This feature works on ITF barcodes only.
          
          Default is 10
          */
        this.minimum1DBarcodesQuietZone = 10;
        /**
          If `true`, check digits for UPC, EAN and MSI Plessey codes are removed from the result. Has no effect if both single and double digit MSI Plessey checksums are enabled. The default is `false`.
          
          Default is false
          */
        this.stripCheckDigits = false;
        /**
          If `true`, the optional check digit for IATA_2_OF_5 codes is used in validation. The default is `true`.
          
          Default is true
          */
        this.useIATA2OF5Checksum = true;
        /**
          If `true`, the optional check digit for CODE_11 codes is used in validation. The default is `true`.
          
          Default is true
          */
        this.useCode11Checksum = true;
        /**
          List of accepted barcode symbologies.
          
          Defaults to common types.
          */
        this.barcodeFormats = [
            'AZTEC',
            'CODABAR',
            'CODE_39',
            'CODE_93',
            'CODE_128',
            'DATA_MATRIX',
            'DATABAR',
            'DATABAR_EXPANDED',
            'DATABAR_LIMITED',
            'EAN_13',
            'EAN_8',
            'ITF',
            'MICRO_QR_CODE',
            'PDF_417',
            'QR_CODE',
            'UPC_A',
            'UPC_E',
        ];
        /**
          Checksum algorithm used for MSI Plessey barcodes. The default value is MOD_10.
          
          Default is MOD_10
          */
        this.msiPlesseyChecksumAlgorithm = 'MOD_10';
        /**
          The customer format used in AUSTRALIA_POST codes. The default value is ALPHA_NUMERIC.
          
          Default is ALPHA_NUMERIC
          */
        this.australiaPostCustomerFormat = 'ALPHA_NUMERIC';
        /**
          If `true`, enables a mode that slightly decreases scanning quality and energy consumption. Increases scanning speed. If `false`, the mode is disabled. The default is `false`. Android only.
          
          Default is false
          */
        this.lowPowerMode = false;
        /**
          The expected way of handling GS1_COMPOSITE barcodes.
          
          Default is PARSE
          */
        this.gs1Handling = 'PARSE';
        /**
          If `true`, the barcode image is returned in the result.
          
          Default is false
          */
        this.returnBarcodeImage = false;
        if (source.extractedDocumentFormats !== undefined) {
            this.extractedDocumentFormats = source.extractedDocumentFormats.map((it) => {
                return it;
            });
        }
        if (source.onlyAcceptDocuments !== undefined) {
            this.onlyAcceptDocuments = source.onlyAcceptDocuments;
        }
        if (source.extensions !== undefined) {
            this.extensions = source.extensions;
        }
        if (source.barcodesRegexFilter !== undefined) {
            this.barcodesRegexFilter = source.barcodesRegexFilter;
        }
        if (source.minimumSizeScore !== undefined) {
            this.minimumSizeScore = source.minimumSizeScore;
        }
        if (source.minimumTextLength !== undefined) {
            this.minimumTextLength = source.minimumTextLength;
        }
        if (source.maximumTextLength !== undefined) {
            this.maximumTextLength = source.maximumTextLength;
        }
        if (source.minimum1DBarcodesQuietZone !== undefined) {
            this.minimum1DBarcodesQuietZone = source.minimum1DBarcodesQuietZone;
        }
        if (source.stripCheckDigits !== undefined) {
            this.stripCheckDigits = source.stripCheckDigits;
        }
        if (source.useIATA2OF5Checksum !== undefined) {
            this.useIATA2OF5Checksum = source.useIATA2OF5Checksum;
        }
        if (source.useCode11Checksum !== undefined) {
            this.useCode11Checksum = source.useCode11Checksum;
        }
        if (source.barcodeFormats !== undefined) {
            this.barcodeFormats = source.barcodeFormats.map((it) => {
                return it;
            });
        }
        if (source.msiPlesseyChecksumAlgorithm !== undefined) {
            this.msiPlesseyChecksumAlgorithm = source.msiPlesseyChecksumAlgorithm;
        }
        if (source.australiaPostCustomerFormat !== undefined) {
            this.australiaPostCustomerFormat = source.australiaPostCustomerFormat;
        }
        if (source.lowPowerMode !== undefined) {
            this.lowPowerMode = source.lowPowerMode;
        }
        if (source.gs1Handling !== undefined) {
            this.gs1Handling = source.gs1Handling;
        }
        if (source.returnBarcodeImage !== undefined) {
            this.returnBarcodeImage = source.returnBarcodeImage;
        }
    }
}
//# sourceMappingURL=BarcodeScannerConfiguration.js.map